export enum FeatureToggle {
  FEATURED_DEALER_3_MONTHS = "FEATURED_DEALER_3_MONTHS",
  FEATURED_DEALER_6_MONTHS = "FEATURED_DEALER_6_MONTHS",
}

export const FEATURE_TOGGLE_KEYS = Object.values(FeatureToggle);
